import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: 12,
  },
  descriptionText: {
    margin: 0,
    color: theme.palette.text.secondary,
  },
  paperGroup: {
    display: 'flex',
    flexDirection: 'column',
    flexWrap: 'nowrap',
    alignItems: 'stretch',
    gap: 6,
    width: 'calc(100% + 24px)',
    marginRight: -24,
    maxHeight: 'min(52vh, 420px)',
    overflowY: 'auto',
    boxSizing: 'border-box',
    padding: '1px 24px 1px 1px',
  },
  paperOption: {
    width: '100%',
    boxSizing: 'border-box',
    margin: 0,
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: 0,
    alignItems: 'center',
    transition: 'border-color 0.2s ease, box-shadow 0.2s ease',
  },
  paperOptionSelected: {
    borderColor: theme.palette.secondary.main,
    boxShadow: `0 0 0 1px ${theme.palette.secondary.main}`,
  },
  paperOptionLabel: {
    width: '100%',
  },
}));
